module.exports = __webpack_public_path__ + "static/cad-designs26-fd868857ede59ed52dd6d3be4338959a.png";